<template>
  <div class="uc-Exam-box">
    <section class="g-headerExam">
      <div class="container">
        <div class="row">
          <div class="col-24 box">
            <router-link to="/" class="logo"
              ><img :src="$store.getters.user.company_logo"
            /></router-link>
            <div class="title">考试情况查询</div>
          </div>
        </div>
      </div>
    </section>
    <div class="g-headerExamSpace"></div>

    <section class="container-fluid g-ExamPercentBox">
      <div class="container">
        <div class="col-20 box">
          <div class="title">{{ model.paper_name }}</div>
        </div>
      </div>
    </section>
    <div class="g-ExamPercentBoxSpace"></div>

    <section class="container-fluid uc-bg g-examInfo">
      <div class="container">
        <div class="box">
          <div class="item">
            <span class="txt">考 生 姓 名：</span
            >{{ $store.getters.user.first_name }}
          </div>
          <div class="item">
            <span class="txt">答题时间始：</span>{{ model.start_time }}
          </div>
          <div class="item">
            <span class="txt">答题时间止：</span>{{ model.end_time }}
          </div>
          <div class="item">
            <span class="txt">答 题 时 间：</span>{{ model.duration }}分钟
          </div>
          <div class="item">
            <span class="txt">考 生 耗 时：</span
            ><span v-if="model.spent_time >= 60"
              >{{ parseInt(model.spent_time / 60) }}分钟</span
            ><span v-if="model.spent_time % 60 > 0"
              >{{ model.spent_time % 60 }}秒</span
            >
          </div>
          <div class="item">
            <span class="txt">试 卷 总 分：</span>{{ model.total_score }}分
          </div>
          <div class="item">
            <span class="txt">通 过 分 数：</span>{{ model.pass_score }}分
          </div>
          <div class="item">
            <span class="txt">考 生 成 绩：</span>{{ model.user_score }}分
          </div>
          <div class="item">
            <span class="txt">标准题得分：</span>{{ model.auto_score }}分
          </div>
          <div class="item">
            <span class="txt">手工题得分：</span
            >{{ model.manual_score ? model.manual_score + '分' : '无' }}
          </div>
          <div class="item">
            <span class="txt">评 分 方 式：</span
            >{{ model.score_way == 1 ? '自动' : '手动' }}
          </div>
          <div class="item">
            <span class="txt">通 过 考 试：</span
            >{{ model.is_pass ? '通过' : '未通过' }}
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid uc-bg uc-Exam">
      <div class="container">
        <div class="list">
          <div v-for="(item, index) in model.question_type_list" :key="index">
            <div class="title">
              {{ item.index }}、{{ item.type_name }} (共{{
                item.question_count
              }}道题)
            </div>
            <div v-for="(item2, index2) in item.question_list" :key="index2">
              <div class="item">
                <!-- 非填空题的题干 -->
                <div class="sub-title" v-if="item2.question_type != 4">
                  <div
                    v-if="
                      item2.question_type == 1 ||
                        item2.question_type == 2 ||
                        item2.question_type == 3
                    "
                  >
                    <img
                      src="../../assets/images/ok.png"
                      class="result-icon"
                      v-if="item2.user_score > 0"
                    />
                    <img
                      src="../../assets/images/error.png"
                      class="result-icon"
                      v-else
                    />
                  </div>
                  <span>{{ index2 + 1 }}.</span>
                  <div class="qst-con w-e-text" v-html="item2.content"></div>
                  <small>({{ item2.score }}分)</small>
                </div>
                <!-- 填空题题干 -->
                <div class="input-box" v-if="item2.question_type == 4">
                  <span>{{ index2 + 1 }}.</span>
                  <div class="qst-con w-e-text">
                    <div
                      class="input-item"
                      v-for="(item3, index3) in item2.content.split('()')"
                      :key="index3"
                    >
                      <div v-html="item3"></div>
                      <input
                        disabled
                        type="text"
                        class="uc-input uc-w300"
                        v-if="index3 != item2.option_count"
                        v-model.trim="item2.user_answer[index3]"
                      />
                    </div>
                  </div>
                  <small>({{ item2.score }}分)</small>
                </div>
                <!-- 单选题、判断题 -->
                <el-radio-group
                  disabled
                  v-model="item2.user_answer"
                  class="choose-box"
                  v-if="item2.question_type == 1 || item2.question_type == 3"
                >
                  <el-radio
                    :label="item3.value"
                    v-for="(item3, index3) in item2.option_list"
                    :key="index3"
                    class="choose-item"
                    >{{ item3.index }}. {{ item3.content }}</el-radio
                  >
                </el-radio-group>
                <!-- 多选题 -->
                <el-checkbox-group
                  disabled
                  v-model="item2.user_answer"
                  class="choose-box"
                  v-if="item2.question_type == 2"
                >
                  <el-checkbox
                    :label="item3.value"
                    v-for="(item3, index3) in item2.option_list"
                    :key="index3"
                    class="choose-item"
                    >{{ item3.index }}. {{ item3.content }}</el-checkbox
                  >
                </el-checkbox-group>
                <!-- 问答题 -->
                <div class="textarea-box" v-if="item2.question_type == 5">
                  <textarea
                    disabled
                    class="uc-textarea"
                    cols="30"
                    rows="10"
                    v-model.trim="item2.user_answer"
                  ></textarea>
                </div>
                <!-- 题目答案、解析 -->
                <div class="textarea-box">
                  <div class="right-answer-box">
                    <div class="three-title">
                      <span
                        >标准答案：<i class="uc-green">{{
                          item2.answer ? item2.answer : '无'
                        }}</i></span
                      >
                      <span>本题分数：{{ item2.score }}分</span
                      ><span>您的得分：{{ item2.user_score }}分</span>
                    </div>
                    <div class="con">
                      <div class="txt">
                        <img
                          src="../../assets/images/icon-answer.png"
                          class="uc-icon20"
                        />
                        解析：
                      </div>
                      {{ item2.analysis ? item2.analysis : '无' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      class="uc-fixedAnswerSheetSideList"
      :class="showSide ? 'on' : ''"
      v-if="model.history_records.length > 1"
    >
      <button class="btns" hover-class="none" @click="btnShowSideList">
        历史成绩
      </button>
      <div class="title">
        我的成绩
        <div class="r">
          通过分数: <i class="uc-blue">{{ model.pass_score }}分</i>
        </div>
      </div>
      <div class="list">
        <div
          class="item"
          v-for="(item, index) in model.history_records"
          :key="index"
        >
          <div class="number">{{ item.user_score }}分</div>
          <div class="time">{{ item.start_time }}</div>
          <span class="uc-tag green-light" v-if="item.is_pass">已通过</span>
          <span class="uc-tag red-light" v-else>未通过</span>
          <router-link
            :to="{ name: 'ExamRecord', params: { id: item.answer_id } }"
            class="uc-btn blue"
            >查看详情</router-link
          >
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ExamRecord',
  components: {},
  data() {
    return {
      showSide: true,
      query: {
        id: this.$route.params.id,
      },
      model: {
        history_records: [],
      },
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.query.id = to.params.id;
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.getRecord();
    },
    async getRecord() {
      const response = await this.$api.exam.getRecord(this.query);
      const { code, data } = response.data;
      this.model = data;
    },
    btnShowSideList() {
      this.showSide = !this.showSide;
    },
  },
};
</script>
